import Button from 'src/components/common/button/button';

import IntroImage from '../../../../assets/images/quiz/intro-3.svg';
import styles from './we-got-you-step.module.scss';

export const WeGotYouStep = ({ onChange }: { onChange: () => void }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <IntroImage />
    </div>
    <footer className={styles.footer}>
      <h1 className={styles.title}>We got you</h1>
      <p className={styles.text}>
        Eclipse will add your goals to your Personal Plan. Now a few more
        questions to increase your Plan’s fit
      </p>
      <Button onClick={() => onChange()}>Continue</Button>
    </footer>
  </div>
);
